export const BASE_API_URL = "https://rgformbuilder.azurewebsites.net/";
// dev
// export const BASE_API_URL = "https://stagingrgformbuilder.azurewebsites.net/";
export const CORS_URL = "https://cors-anywhere.herokuapp.com/";

//Admin
export const ADMIN_USERS_URL = BASE_API_URL + "user/listUser";
export const ADMIN_DASHBOARD_URL = BASE_API_URL + "report/getAdminDashboard";
export const ADMIN_USERS_CREATE_URL = BASE_API_URL + "user/createUser";
export const ADMIN_USERS_UPDATE_URL = BASE_API_URL + "user/updateUser";
export const USER_DETAILS_URL = BASE_API_URL + "/user/selectUser";
export const USER_DELETE_URL = BASE_API_URL + "user/deleteUser";
export const ADMIN_CHANGE_PASSWORD = BASE_API_URL + "user/changePassword";

// Instructions
export const CREATE_INSTRUCTIONS =
  BASE_API_URL + "instruction/createInstruction";
export const UPDATE_INSTRUCTIONS =
  BASE_API_URL + "instruction/updateInstruction";
export const GET_INSTRUCTIONS = BASE_API_URL + "instruction/getInstruction";
export const DELETE_INSTRUCTIONS =
  BASE_API_URL + "instruction/deleteInstruction";
export const LIST_INSTRUCTIONS = BASE_API_URL + "instruction/listInstructions";
export const UPSERT_INSTRUCTIONS =
  BASE_API_URL + "instruction/upsertInstruction";

//common
export const REQUEST_STATUS_CHANGE =
  BASE_API_URL + "agency/updateServiceStatus";
export const LOGIN_URL = BASE_API_URL + "user/login";
export const SEND_OTP = BASE_API_URL + "user/sendForgetPasswordOTP";
export const UPDATE_PASSWORD = BASE_API_URL + "user/updatePassword";
export const FILE_UPLOAD_URL = BASE_API_URL + "uploadFile/uploadFile";
export const PDF_PAGES_SPLIT_INTO_DOCUMENTS_URL =
  BASE_API_URL + "uploadFile/uploadPDFSplitFile";
export const FIRSTTIME_UPDATEPASSWORD_URL =
  BASE_API_URL + "user/firstTimeUpdatePassword";

//Agency
export const AGENCYLIST_URL = BASE_API_URL + "agency/getAgency";
export const AGENCY_DASHBOARD_URL = BASE_API_URL + "/report/getAgencyDashboard";
export const AGENCY_DELETE = BASE_API_URL + "agency/deleteAgencyList";
export const REQUESTLIST_URL = BASE_API_URL + "agency/getAgencyService";
export const USER_LIST_DELETE = BASE_API_URL + "user/deleteUserList";
export const USER_DELETE_AGENCY_LIST =
  BASE_API_URL + "agency/deleteAgencyServiceList";
export const AGENCY_DOCUMENT_CREATE_URL =
  BASE_API_URL + "agency/createAgencyService";
export const AGENCY_DOCUMENT_UPDATE_URL =
  BASE_API_URL + "agency/updateAgencyService";
export const AGENCY_DOCUMENT_DELETE_URL =
  BASE_API_URL + "agency/deleteAgencyService";
export const AGENCY_CHECK_DOCUMENT_URL_EXIST =
  BASE_API_URL + "agency/checkDomainURLExist";
export const AGENCY_DETAILS_URL = BASE_API_URL + "agency/getAgencyDetailById";
export const AGENCY_UPDATE = BASE_API_URL + "agency/updateAgency";
export const AGENCY_CREATE_URL = BASE_API_URL + "agency/createAgency";
export const AGENCY_UPDATE_URL = BASE_API_URL + "agency/updateAgency";
export const AGENCY_USER_LIST_URL = BASE_API_URL + "agency/listAgencyUser";
export const AGENCY_USER_CREATE_URL = BASE_API_URL + "agency/createAgencyUser";
export const AGENCY_USER_UPDATE_URL = BASE_API_URL + "agency/updateAgencyUser";
export const AGENCY_DOCUMENT_DETAILS_URL =
  BASE_API_URL + "agency/getAgencyServiceById";
export const AGENCY_DOCUMENT_CHECK_HYPERLINK_AVAILABLE_URL =
  BASE_API_URL + "agency/checkDomainURLExist";
export const AGENCY_SERVICEREQUEST_LIST_URL =
  BASE_API_URL + "agency/getServiceRequest";

export const DOCUMENT_VARIABLE_LIST_URL =
  BASE_API_URL + "agency/selectExtraFeeDetailsById";
export const DOCUMENT_VARIABLE_CREATE_URL =
  BASE_API_URL + "agency/createExtraFee";
export const DOCUMENT_VARIABLE_UPDATE_URL =
  BASE_API_URL + "agency/updateExtraFee";
export const DOCUMENT_VARIABLE_DELETE_URL =
  BASE_API_URL + "agency/deleteExtraFee";
export const GET_LOCATION_CODE =
  BASE_API_URL + "agency/getLocationCodeDetailById";
export const ALL_AGENCY_LIST =
  BASE_API_URL + "agency/searchOrganization";

//customer
export const CUSTOMERLIST_URL = BASE_API_URL + "endUser/listEndUser";
export const CUSTOMER_DETAILS_URL = BASE_API_URL + "agency/getCustomerHistory";
export const GET_DOCUMENT_DETAILS_URL =
  BASE_API_URL + "agency/getAgencyServiceDetails";
export const POST_ENDUSER_CREATE_URL = BASE_API_URL + "endUser/createEndUser";
export const GET_AGENCY_CONVENIENCE_FEE_URL =
  BASE_API_URL + "payment/getAgencyFee";
export const GET_END_USER_DOCUMENT_DETAILS_URL =
  BASE_API_URL + "agency/getAgencyServiceDetailsForCustomer";

//Payment
export const POST_PROCESSPAYMENT_URL =
  BASE_API_URL + "payment/paymentProcessingService";

//Customer
export const CREATE_CUSTOMER_URL = BASE_API_URL + "customer/createCustomer";
export const LIST_CUSTOMER_URL = BASE_API_URL + "customer/listCustomer";
export const SELECT_CUSTOMER_URL = BASE_API_URL + "customer/selectCustomer";
export const EDIT_CUSTOMER_URL = BASE_API_URL + "customer/updateCustomer";
export const DELETE_CUSTOMER_URL = BASE_API_URL + "customer/deleteCustomer";

//Coupons
export const LIST_COUPONS_URL = BASE_API_URL + "coupon/listCoupon";
export const CREATE_COUPONS_URL = BASE_API_URL + "coupon/createCoupon";
export const SELECT_COUPONS_URL = BASE_API_URL + "coupon/selectCoupon";
export const UPDATE_COUPONS_URL = BASE_API_URL + "coupon/updateCoupon";
export const DELETE_COUPONS_URL = BASE_API_URL + "coupon/deleteCoupon";
export const APPLY_COUPON_URL = BASE_API_URL + "coupon/applyCoupon";
export const REMOVE_COUPON_URL = BASE_API_URL + "coupon/removeCoupon";

//Invoice
export const CREATE_INVOICE_URL = BASE_API_URL + "invoice/createInvoice";
export const UPDATE_INVOICE_URL = BASE_API_URL + "invoice/updateInvoice";
export const SAVE_INVOICE_URl = BASE_API_URL + "invoice/saveInvoiceItems";
export const SELECT_INVOICE_URL = BASE_API_URL + "invoice/selectInvoice";
export const LIST_INVOICE_URL = BASE_API_URL + "invoice/listInvoice";
export const DELETE_INVOICE_URL = BASE_API_URL + "invoice/deleteInvoice";

//Subscriptions
export const CREATE_SUBSCRIPTION_URL =
  BASE_API_URL + "subscription/createSubscription";
export const UPDATE_SUBSCRIPTION_URL =
  BASE_API_URL + "subscription/updateSubscription";
export const SELECT_SUBSCRIPTION_URL =
  BASE_API_URL + "subscription/selectSubscription";
export const DELETE_SUBSCRIPTION_URL =
  BASE_API_URL + "subscription/deleteSubscription";
export const LIST_SUBSCRIPTION_URL =
  BASE_API_URL + "subscription/listSubscription";
export const VALIDATE_PAYMENT = BASE_API_URL + "invoice/validatePayment";
export const INVOICE_PAYMENT_HISTORY =
  BASE_API_URL + "invoicePayment/listInvoicePaymentHistory";
export const PROCEED_PAYMENT =
  BASE_API_URL + "invoicePayment/paymentProcessingService";
export const RESEND_PAYMENT_LINK = BASE_API_URL + "invoice/resendPaymentLink";

//WebForm Reports
export const GET_WEBFORM_LIST = BASE_API_URL + "report/getWebForms";
export const GET_WEBFORM_USER = BASE_API_URL + "report/getWebFormUser";

//LocationCode
export const LOCATION_CODE_LISTING_URL =
  BASE_API_URL + "agency/getLocationCodeDetailById";
